<template>
  <header>
    <nav class="main-nav-bar">
      <div class="container flex main-nav-bar-in">
        <router-link :to="{ path: '/user/home' }" class="logo">
          {{ $store.state.title }}
        </router-link>

        <el-menu mode="horizontal" class="main-nav" router>
          <template
            v-for="(it, index) in navList"
          >
            <el-menu-item
              :key="index"
              :index="String(index)"
              :route="{ path: it.path }"
              class="nav-item"
              :class="it.isOn && 'nav-item-on'"
              v-if="it.subList == null"
            >{{it.name}}</el-menu-item>
            <el-submenu
              :key="index"
              :index="String(index)"
              class="nav-item"
              :class="it.isOn && 'nav-item-on'"
              popper-class="main-nav-popper"
              v-else
            >
              <template slot="title">{{it.name}}</template>
              <el-menu-item
                v-for="(sub, i) in it.subList"
                :key="i"
                :index="`${index}-${i}`"
                :route="{ path: sub.path }"
                :class="`sub-item sub-item-${sub.key}`"
              >{{sub.name}}</el-menu-item>
            </el-submenu>
          </template>
        </el-menu>

        <div v-if="$route.meta.useSearch" class="search-wrap">
          <input v-model="search" type="text" placeholder="请输入课程名称" class="search-input" @keyup.enter="searchSubmit">
          <button type="button" class="search-button" @click="searchSubmit"></button>
        </div>

        <nav class="auth-nav">
          <template v-if="isLogin">
            <span class="nav-user-name">{{username}}</span>
            <a class="nav-logout" @click="logout">退出</a>
          </template>
          <template v-else>
            <router-link :to="{ path: '/login' }" class="nav-login">登录</router-link>
            <router-link :to="{ path: '/register' }" class="nav-register"> &nbsp;|&nbsp; 注册</router-link>
          </template>
        </nav>
      </div>
    </nav>
  </header>
</template>

<script>
import mixins from '@/util/mixins'
import event from '@/util/event'
import { syncCeping } from '@/util/ceping'
import { debounce } from 'lodash'
import { userManageConds } from '@/store'

export default {
  name: 'topNav',

  mixins: [ mixins ],

  props: {
    home: {
      type: Boolean,
      default: false
    }
  },

  data() {
    const { keyword } = userManageConds()
    return {
      search: keyword,
      delaySearch: null
    }
  },

  computed: {
    backColor() {
      return this.$store.state.head_color || '#ef662f'
    },

    isLogin() {
      return !!this.$store.state.uname
    },

    username() {
      return this.$store.state.uname
    },

    logo() {
      return this.$store.state.title
    },

    logoImage() {
      return this.$store.state.logo
    },

    role() {
      return this.$store.state.role
    },

    isCeping() {
      return this.$store.state.isCeping
    },

    isUpPack() {
      return this.$store.state.is_up_pack
    },

    navList() {
      const role = this.role
      const { nav } = this.$route.meta || {}
      if (role === 'user') {
        const subList = [
          { name: '我的课程', path: '/user/home', key: 'home' },
          { name: '我的作业', path: '/user/myhomework', key: 'myhomework' },
          // { name: '我的问答', path: '/user/myask' },
          // { name: '测评', path: '/user/ceping' },
        ]
        // this.isCeping && subList.push({ name: '测评推荐课程', path: '/user/recommendCourse' })
        return [
          // { name: '首页', path: '/', isOn: nav == 'home' },
          { name: '课程', path: '/user/manage', isOn: nav == 'course' },
          // { name: '实战问答', path: '/user/ask', isOn: nav == 'ask' },
          { name: '推荐热点', path: '/user/talk', isOn: nav == 'talk' },
          { name: '职场续航', path: '/user/article', isOn: nav == 'article' },
          { name: '下载', path: '/user/download', isOn: nav == 'download' },
          { name: '个人中心', isOn: nav == 'my', subList },
        ]
      } else if (role === 'admin') {
        const navLists = [
          { name: '首页', path: '/', isOn: nav == 'home' },
          { name: '员工管理', path: `/admin/saff`, isOn: nav == 'saff' },
          { name: '课程管理', path: `/admin/manage`, isOn: nav == 'course' },
          { name: '作业管理', path: `/admin/homework`, isOn: nav == 'homework' },
          /*{ name: '订购管理', path: `/admin/setting`, isOn: nav == 'setting' },
          { name: '充值管理', path: `/admin/recharge`, isOn: nav == 'recharge' },*/
        ]

        this.isUpPack && navLists.push({ name: '充值管理', path: `/admin/recharge`, isOn: nav == 'recharge' });

        return navLists;
      }
      return []
    }
  },

  created() {
    this.updateCeping()
    this.delaySearch = debounce(() => this.searchSubmit(), 588)
  },

  methods: {
    logout() {
      this.$store.commit('logout')
      this.$router.push({ name: 'Login' })
    },

    searchSubmit() {
      const keyword = (this.search || '').trim()
      event.$emit('headerSearchChange', { keyword })
    },

    async updateCeping() {
      if (this.isLogin && this.role == 'user') {
        const { isCeping } = await syncCeping()
        this.$store.commit('setValue', { isCeping })
      } else {
        this.$store.commit('setValue', { isCeping: false })
      }
    }
  },

  watch: {
    isLogin() {
      this.updateCeping()
    },

    // search() {
    //   this.delaySearch.cancel()
    //   this.delaySearch()
    // }
  },
}
</script>

<style lang="scss">
.main-nav-popper {
  margin: -10px 0 0 0;
  .el-menu--popup {
    padding: 6px 16px;
    overflow: hidden;
    min-width: 100px;
    text-align: center;
    border-radius: 20px;
  }
  .el-menu-item {
    display: flex;
    align-items: center;
    gap: 15px;
    color: #333 !important;
    font-size: 16px;
    height: 32px !important;
    line-height: 32px !important;
    padding: 0 26px 0 11px !important;
    margin: 15px 0;
    border-radius: 4px;
    &:hover {
      background-color: #f5f5f5 !important;
    }
    &::before {
      content: '';
      display: block;
      width: 32px;
      height: 32px;
      background: url(~@/assets/new/course.png) no-repeat center / contain;
    }
  }
  .sub-item-myhomework::before {
    background-image: url(~@/assets/new/work.png);
  }
}
</style>

<style lang="scss" scoped>
@import '../assets/style/colors.scss';
.auth-nav {
  display: flex;
  gap: 35px;
}

header {
  user-select: none;
}

.top-nav {
  display: flex;
  height: 80px;
  line-height: 80px;
}

.top-nav-in {
  align-items: center;
  justify-content: space-between;
}

.main-nav-bar {
  display: flex;
  align-items: center;
  width: 100%;
  height: 90px;
  background-color: #333;
  .logo {
    margin-right: 50px;
  }
}

.main-nav-bar-in {
  display: flex;
  align-items: center;
  height: 100%;
}

.logo {
  display: flex;
  height: 100%;
  align-items: center;
  color: #F0AD3D;
  font-size: 22px;
}

.logo-img {
  min-width: 90px;
  max-width: 580px;
  height: 50px;
}

.main-nav {
  flex: 1;
  display: flex;
  height: 100%;
  align-items: center;
  border: 0;
  background-color: transparent;
}

.nav-item {
  position: relative;
  display: inline-flex;
  align-items: center;
  height: 100%;
  box-sizing: border-box;
  overflow: hidden;
  color: #fff !important;
  font-size: 16px;
  padding: 0 20px;
  border: 0 !important;
  &:hover,
  &:focus {
    color: #fff !important;
    background-color: transparent !important;
  }

  &:focus {
    color: #fff !important;
  }

  /deep/.is-active:not(.nav-item-on) {
    border-bottom-color: transparent !important;
  }
}

.nav-item-on {
  background: linear-gradient(
    to bottom,
    #F2AE2D 0 76px,
    transparent 77px 90px
  ) no-repeat;
}

.main-nav /deep/ .el-submenu {
  padding: 0;
}

.main-nav /deep/ .el-submenu__title {
  color: #fff !important;
  background-color: transparent !important;
  border-bottom: 0 !important;
  padding: 0 7px 0 20px !important;
  font-size: 16px;
  display: flex;
  height: 100%;
  align-items: center;
}

.main-nav /deep/ .el-icon-arrow-down {
  color: #fff;
  font-size: 14px;
  margin: 3px 0 0 5px;
}

.nav-logout,
.nav-login,
.nav-register,
.nav-user-name {
  font-size: 16px;
  display: inline-block;
  color: #fff;
  user-select: none;
}

.nav-user-name {
  color: #F2AE2D;
}

.nav-logout {
  cursor: pointer;
}

.search-wrap {
  position: relative;
  margin-right: 29px;
}

.search-input {
  width: 260px;
  height: 54px;
  border-radius: 27px;
  background-color: #fff;
  border: 1px solid #E8E8E8;
  outline: 0;
  padding: 0 23px;
  box-sizing: border-box;
  color: #666;
  font-size: 16px;
  &::placeholder {
    color: #999;
  }
}

.search-button {
  position: absolute;
  top: 0;
  right: 17px;
  width: 24px;
  height: 100%;
  background: url(~@/assets/new/search.png) no-repeat center / contain;
  border: 0;
}
</style>




// WEBPACK FOOTER //
// src/components/topNav.vue